/**
 * A42E/A42F — line icons of the "Essayage B2" design (stroke 1.5–2, round caps).
 * Decorative only: the accessible name always lives on the surrounding control.
 */
const ICONS = {
  close: { w: 18, h: 18, sw: 1.6, body: '<path d="M6 6l12 12M18 6L6 18"/>' },
  help: { w: 18, h: 18, sw: 1.5, body: '<circle cx="12" cy="12" r="9"/><path d="M9.6 9.4a2.5 2.5 0 1 1 3.4 2.4c-.6.3-1 .8-1 1.5v.6M12 16.8v.1"/>' },
  size: { w: 18, h: 18, sw: 1.5, body: '<path d="M3 12h18M6.5 8.5L3 12l3.5 3.5M17.5 8.5L21 12l-3.5 3.5"/>' },
  colours: { w: 18, h: 18, sw: 1.5, body: '<circle cx="9" cy="12" r="5.5"/><circle cx="15" cy="12" r="5.5"/>' },
  frames: { w: 20, h: 18, sw: 1.5, body: '<circle cx="6.5" cy="13" r="3.8"/><circle cx="17.5" cy="13" r="3.8"/><path d="M10.3 12.6c1.1-.8 2.3-.8 3.4 0M2.7 12.5L4 8M21.3 12.5L20 8"/>' },
  check: { w: 14, h: 14, sw: 2, body: '<path d="M5 12.5l4.5 4.5L19 7.5"/>' },
  reset: { w: 14, h: 14, sw: 1.8, body: '<path d="M4 12a8 8 0 1 0 2.4-5.7M4 4v4.5h4.5"/>' },
  arrow: { w: 16, h: 16, sw: 1.6, body: '<path d="M5 12h14M13 6l6 6-6 6"/>' },
  /** A110T: landscape (sun over hills) for « Voir le paysage ». */
  landscape: { w: 16, h: 16, sw: 1.6, body: '<path d="M2.5 19l6-7.5 4.2 5 2.8-3.3 6 5.8"/><circle cx="16.5" cy="7" r="2.3"/>' },
  /** A110T: half-filled circle for « Sans verre » (compare). */
  compare: { w: 16, h: 16, sw: 1.6, body: '<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5v17" /><path d="M12 3.5a8.5 8.5 0 0 1 0 17z" fill="currentColor" stroke="none"/>' },
  /** A110U: camera with turning arrows — « Revenir à la caméra avant » (leaves « Voir le paysage »). */
  cameraFront: { w: 20, h: 20, sw: 1.6, body: '<path d="M3.5 8.6a2 2 0 0 1 2-2h2.1l1.5-2.1h5.8l1.5 2.1h2.1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z"/><path d="M8.7 12.3a3.4 3.4 0 0 1 6.1-1.5"/><path d="M15.2 8.9v2.1h-2.1"/><path d="M15.3 14.3a3.4 3.4 0 0 1-6.1 1.5"/><path d="M8.8 17.7v-2.1h2.1"/>' },
  grid: { w: 15, h: 15, sw: 1.5, body: '<rect x="4" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5"/><rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5"/><rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5"/>' },
  /** A110V « Je la veux » (pill item, heart outline). */
  heart: { w: 18, h: 18, sw: 1.5, body: '<path d="M12 19.6c-.4 0-7.6-4.5-7.6-9.8A4.2 4.2 0 0 1 12 7.4a4.2 4.2 0 0 1 7.6 2.4c0 5.3-7.2 9.8-7.6 9.8z"/>' },
  /** A110V: speech bubble — « Commander sur WhatsApp ». */
  chat: { w: 16, h: 16, sw: 1.6, body: '<path d="M20 11.6a7.6 7.6 0 0 1-11.2 6.7l-4.3 1.2 1.3-3.9A7.6 7.6 0 1 1 20 11.6z"/>' },
  /** A110V: arrow into a tray — « Enregistrer la photo ». */
  save: { w: 16, h: 16, sw: 1.6, body: '<path d="M12 4v11M7.5 10.5L12 15l4.5-4.5M5 19.5h14"/>' },
  /** A110V: arrow out of a box — « Partager la photo » (devices with a share sheet). */
  share: { w: 16, h: 16, sw: 1.6, body: '<path d="M12 14.5V4M8.2 7.6L12 4l3.8 3.6M8 10.5H6.5A1.5 1.5 0 0 0 5 12v6.5A1.5 1.5 0 0 0 6.5 20h11a1.5 1.5 0 0 0 1.5-1.5V12a1.5 1.5 0 0 0-1.5-1.5H16"/>' },
  /** A110V: shopping bag — « Ajouter au panier ». */
  bag: { w: 16, h: 16, sw: 1.6, body: '<path d="M5.5 8.5h13l-1 11h-11z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/>' },
  /** A201 « Annuler » (engraving): an arrow turning back. */
  undo: { w: 16, h: 16, sw: 1.7, body: '<path d="M9 14L4 9l5-5"/><path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11"/>' },
  /** A201 magnifier (« loupe » on the temple). */
  zoom: { w: 16, h: 16, sw: 1.7, body: '<circle cx="10.5" cy="10.5" r="6"/><path d="M15 15l5 5M8 10.5h5M10.5 8v5"/>' },
  /** A201 chevron of the face panels (points down; turned when open). */
  chevron: { w: 14, h: 14, sw: 1.8, body: '<path d="M6 9.5l6 6 6-6"/>' },
  /** A201 « Même chose sur l'autre branche ». */
  copy: { w: 14, h: 14, sw: 1.6, body: '<rect x="8.5" y="8.5" width="11" height="11" rx="2"/><path d="M15.5 8.5V6a1.5 1.5 0 0 0-1.5-1.5H6A1.5 1.5 0 0 0 4.5 6v8A1.5 1.5 0 0 0 6 15.5h2.5"/>' },
  /** A201 « Fiche atelier » (PDF). */
  doc: { w: 16, h: 16, sw: 1.6, body: '<path d="M6.5 3.5h7l4 4v12a1 1 0 0 1-1 1h-10a1 1 0 0 1-1-1v-15a1 1 0 0 1 1-1z"/><path d="M13.5 3.5v4h4M8.5 12.5h7M8.5 16h5"/>' },
} as const;

export type IconName = keyof typeof ICONS;

export function icon(name: IconName, size?: number): SVGSVGElement {
  const spec = ICONS[name];
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', String(size ?? spec.w));
  svg.setAttribute('height', String(size ?? spec.h));
  svg.setAttribute('fill', 'none');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('stroke-width', String(spec.sw));
  svg.setAttribute('stroke-linecap', 'round');
  svg.setAttribute('stroke-linejoin', 'round');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');
  svg.classList.add('mt-icon', `mt-icon--${name}`);
  svg.innerHTML = spec.body;
  return svg;
}

/** Small DOM helper shared by the A42E controls. */
export function h<K extends keyof HTMLElementTagNameMap>(tag: K, className?: string, text?: string): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  if (className) e.className = className;
  if (text !== undefined) e.textContent = text;
  return e;
}

export function btn(className: string, text?: string): HTMLButtonElement {
  const b = h('button', className, text);
  b.type = 'button';
  return b;
}
